import React, { Fragment, useState, useEffect } from 'react';
import moment from "moment";
import ArrowSelectIcon from '../../../../resources/common/arrow_select.svg';

// 참가 고유코드(PARTICIPATION) 로그인 뷰.
// 입력 id = parti_code (Login.js onLoginClick 이 이 값을 participationCode 로 전송).
// 첫 접속 시 약관 동의가 필요하면 패스코드와 동일한 약관 UI(agree_form)를 노출한다(동의는 participationCode 기준).
// 로그인 성공 후 preregEventList 가 오면 패스코드와 동일하게 이벤트 선택 화면을 보여준다.
export default (props) => {
  const {
    siteInfo,
    passcodeNext,
    onLoginClick,
    preregEventList,
    goEventSessionList,
    loginError,
    setLoginError,
    isLoggingIn,
    onSwitchToPasscode,
    passCodeOpt,
    passCodePrivacyOpen,
    passCodeUseOpen,
    passCodeOverseaOpen,
    passCodePrivacyAgree,
    passCodeUseAgree,
    passCodeOverseaAgree,
    setPassCodePrivacyAgree,
    setPassCodeUseAgree,
    setPassCodeOverseaAgree,
    passCodeShowTerms,
  } = props;

  const isEn = siteInfo?.idx == 125;

  // 약관 동의 UI (패스코드 뷰와 동일 로직)
  const [allChecked, setAllChecked] = useState(false);
  const termsCount = [passCodePrivacyOpen, passCodeUseOpen, passCodeOverseaOpen].filter(Boolean).length;
  const handleAllCheckedChange = (value) => {
    setAllChecked(value);
    setPassCodePrivacyAgree(value);
    setPassCodeUseAgree(value);
    setPassCodeOverseaAgree(value);
  };
  useEffect(() => {
    const allCheckedState =
      (passCodePrivacyOpen ? passCodePrivacyAgree : true) &&
      (passCodeUseOpen ? passCodeUseAgree : true) &&
      (passCodeOverseaOpen ? passCodeOverseaAgree : true) &&
      (passCodePrivacyOpen || passCodeUseOpen || passCodeOverseaOpen);
    setAllChecked(allCheckedState);
  }, [passCodePrivacyAgree, passCodeUseAgree, passCodeOverseaAgree]);

  return (
    <div className="login_box psc_box">
      {!passcodeNext && (
        <div className="psc_box1">
          <div style={{ textAlign: "right", marginBottom: "8px" }}>
            <a
              onClick={onSwitchToPasscode}
              style={{ cursor: "pointer", fontSize: "13px", color: "#7b5cff", textDecoration: "underline", whiteSpace: "nowrap" }}
            >
              {isEn ? "Login with passcode" : "패스코드 로그인"}
            </a>
          </div>
          <div className="login_input_div" style={{ display: "flex", alignItems: "center" }}>
            {siteInfo?.accessCodeName ? (
              <span style={{ paddingLeft: "12px", color: "#888", fontWeight: 600, whiteSpace: "nowrap" }}>
                {siteInfo.accessCodeName}-
              </span>
            ) : null}
            <input
              className="login_input"
              id="parti_code"
              type="text"
              placeholder={
                siteInfo?.accessCodeName
                  ? (isEn ? "Enter your code." : "고유코드를 입력해 주세요.")
                  : (isEn ? "Please enter your access code." : "참가 고유코드를 입력해 주세요.")
              }
              defaultValue=""
              onChange={() => {
                if (loginError) setLoginError(null);
              }}
              onKeyPress={(e) => {
                if (e.key == "Enter") {
                  onLoginClick(e);
                }
              }}
              style={loginError ? { borderColor: '#ff4444', flex: 1 } : { flex: 1 }}
            />
          </div>
          {loginError && (
            <div
              className="login_error_message"
              style={{ marginTop: '4px', marginBottom: '0px', color: '#ff4444', fontSize: '13px' }}
            >
              {loginError}
            </div>
          )}
          {(passCodePrivacyOpen == true || passCodeUseOpen == true || passCodeOverseaOpen == true) && (
            <div className="agree_form">
              <ul>
                {termsCount >= 2 && (
                  <li>
                    <p>
                      <input
                        type="checkbox"
                        id="login_agree_all"
                        checked={allChecked}
                        onChange={(e) => handleAllCheckedChange(e.target.checked)}
                      />
                      <label id="chk_label" htmlFor="login_agree_all">
                        <span></span>
                        모두 동의합니다.
                      </label>
                    </p>
                  </li>
                )}
                {passCodePrivacyOpen == true && (
                  <li>
                    <p>
                      <input type="checkbox" id="login_agree_box2" onChange={(e) => setPassCodePrivacyAgree(e.target.checked)} checked={passCodePrivacyAgree}/>
                      <label id="chk_label" htmlFor="login_agree_box2">
                        <span></span>
                        {`${passCodeOpt[0].termsPrivacyFormLabel} ${passCodeOpt[0]?.termsPrivacyFormEsUse == 'Y' ? '(필수)' : '(선택)'}`}
                      </label>
                    </p>
                    <a style={{ cursor: "pointer", whiteSpace: "nowrap" }} onClick={passCodeShowTerms.bind(this, "termsPrivateAgree")}>
                      내용보기
                    </a>
                  </li>
                )}
                {passCodeOverseaOpen == true && (
                  <li>
                    <p>
                      <input type="checkbox" id="login_agree_box3" onChange={(e) => setPassCodeOverseaAgree(e.target.checked)} checked={passCodeOverseaAgree}/>
                      <label id="chk_label" htmlFor="login_agree_box3">
                        <span></span>
                        {`${passCodeOpt[0]?.termsOverseaLabel} ${passCodeOpt[0]?.termsOverseaEsUse == 'Y' ? '(필수)' : '(선택)'}`}
                      </label>
                    </p>
                    <a style={{ cursor: "pointer", whiteSpace: "nowrap" }} onClick={passCodeShowTerms.bind(this, "termsOverseaAgree")}>
                      내용보기
                    </a>
                  </li>
                )}
                {passCodeUseOpen == true && (
                  <li>
                    <p>
                      <input type="checkbox" id="login_agree_box" onChange={(e) => setPassCodeUseAgree(e.target.checked)} checked={passCodeUseAgree}/>
                      <label id="chk_label" htmlFor="login_agree_box">
                        <span></span>
                        {`${passCodeOpt[0]?.termsUseFormLabel} ${passCodeOpt[0]?.termsUseFormEsUse == 'Y' ? '(필수)' : '(선택)'}`}
                      </label>
                    </p>
                    <a style={{ cursor: "pointer" }} onClick={passCodeShowTerms.bind(this, "termsUseAgree")}>
                      내용보기
                    </a>
                  </li>
                )}
              </ul>
            </div>
          )}
          <div className="login_enter">
            <span id="participation_submit_btn" onClick={(e) => onLoginClick(e)}>
              {isLoggingIn ? (isEn ? "Logging in..." : "로그인 중...") : (isEn ? "Enter" : "입장하기")}
            </span>
          </div>
        </div>
      )}
      {passcodeNext && (
        <>
          {preregEventList?.length > 0 && (
            <div className="psc_box2" style={{ display: "block" }}>
              <p>
                총 {preregEventList.length}개의 이벤트에 등록이 되어있습니다.
                <br />
                선택하신 이벤트로 입장하실 수 있습니다.
              </p>
              {preregEventList?.map((item, i) => (
                <Fragment key={i}>
                  <div
                    className="login_session psc_session"
                    onClick={(e) => goEventSessionList(item, e)}
                  >
                    <div className="psc_hd">
                      <h4 className="login_session_h4">
                        <a>{item.name}</a>
                      </h4>
                      <p>
                        <img src={ArrowSelectIcon} alt="펼쳐보기" />
                      </p>
                    </div>
                    {(item?.startDate && item.endDate) ? (
                      <p className="login_session_p">
                        {moment(item?.startDate).format("YYYY.MM.DD(ddd) HH:mm")}{" "}
                        ~{" "}
                        {moment(item?.endDate).format(`${moment(item?.startDate).format('YYYY.MM.DD') == moment(item?.endDate).format('YYYY.MM.DD') ? 'HH:mm' : 'YYYY.MM.DD(ddd) HH:mm'}`)}
                      </p>
                    ) : ""}
                  </div>
                </Fragment>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};
